/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import Base from 'components/common/Base'
import FileImportPage from 'components/staff/FileImportPage'
import PaymentPage from 'components/staff/PaymentPage'
import ApplicantPage from 'components/staff/ApplicantPage'
import * as constants from 'constants/Header'
import * as documentActions from 'actions/Document'

class AdministrationPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      messageParams: undefined,
      loadingCustomer: false,
      loadingInterpreter: false,
      loadingInvoice: false,
      pathname: props.history.location.pathname,
      headerOptions: []
    }

    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.handleXMLUpload = this.handleXMLUpload.bind(this)
    this.handleXLSXUpload = this.handleXLSXUpload.bind(this)
  }

  componentDidMount() {
    if (!this.props.user.paymentAccess && 
        !this.props.user.applicantListAccess &&
        !this.props.user.is_staff) {
      this.props.history.push('/dashboard/')
    }

    let headerOptions = [
      {
        text: constants.messages.CUSTOMER_INTERPRETER_IMPORT_MENU,
        key: '/file/import/',
        show: this.props.user.is_staff,
        component: <FileImportPage
          handleFileUpload={this.handleFileUpload}
          handleUploadFile={this.handleUploadFile}
          handleXMLUpload={this.handleXMLUpload}
          handleXLSXUpload={this.handleXLSXUpload}
          messageParams={this.state.messageParams}
          loadingCustomer={this.state.loadingCustomer}
          loadingInterpreter={this.state.loadingInterpreter}
        />
      },
      {
        text: constants.messages.APPLICANT_LIST_MENU,
        key: '/applicant/list/',
        show: this.props.user.applicantListAccess,
        component: <ApplicantPage/>
      },
      {
        text: constants.messages.PAYMENT_IMPORT_MENU,
        key: '/file/payment/',
        show: this.props.user.paymentAccess,
        component: <PaymentPage
          handleFileUpload={this.handleFileUpload}
          handleUploadFile={this.handleUploadFile}
          handleXMLUpload={this.handleXMLUpload}
          handleXLSXUpload={this.handleXLSXUpload}
          messageParams={this.state.messageParams}
          loadingInvoice={this.state.loadingInvoice}
        />
      },
    ]

    this.setState({
      headerOptions: headerOptions
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== this.state.pathname) {
      this.setState({
        pathname: this.props.history.location.pathname,
      })
    }
  }

  handlePageChange(index) {
    this.setState({
      messageParams: undefined,
    })

    this.props.history.push({pathname: index})
  }

  handleFileUpload(ref) {
    ref.click()
  }

  async handleUploadFile(file, option) {
    this.setState({
      messageParams: undefined,
      [option.loading]: true
    })

    const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    })

    const documentObj = {
      document: base64.split(',')[1],
      name: option.fileName,
      mimetype: 'data:' + file.type
    }

    documentActions.postFile(documentObj)
      .then((documentObj) => {
        this.setState({
          messageParams: {
            [option.message]: {
              color: 'green',
              message: this.props.intl.formatMessage(constants.messages.FILE_IMPORTED_SUCCESSFULLY)
            }
          }
        })
      })
      .then((result) => {
        this.setState({
          [option.loading]: false
        })
      })
  }

  async handleXMLUpload(event, option) {
    const file = event.target.files[0]

    if (['text/xml'].indexOf(file.type) === -1) {
      this.setState({
        messageParams: {
          [option.message]: {
            color: 'red',
            message: this.props.intl.formatMessage(constants.messages.XML_ACCEPTED_ONLY)
          }
        }
      })

      return
    }

    this.handleUploadFile(file, option)
    event.target.value = ''
  }

  handleXLSXUpload(event, option) {
    const file = event.target.files[0]

    if (['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].indexOf(file.type) === -1) {
      this.setState({
        messageParams: {
          [option.message]: {
            color: 'red',
            message: this.props.intl.formatMessage(constants.messages.XLSX_ACCEPTED_ONLY)
          }
        }
      })

      return
    }

    this.handleUploadFile(file, option)
    event.target.value = ''
  }

  render () {
    if (!this.state.headerOptions.length) {
      return (<React.Fragment></React.Fragment>)
    }

    return (
      <Base
        headerOptions={this.state.headerOptions}
        page={this.state.pathname}
        handlePageChange={this.handlePageChange}
      >
        {
          this.state.headerOptions.map((headerOption, key) => {
            if (headerOption.key === this.state.pathname) {
              return headerOption.component
            }

            return
          })
        }
      </Base>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

export default connect(
  mapStateToProps, 
  undefined
)(injectIntl(AdministrationPage))



// WEBPACK FOOTER //
// ./src/components/pages/AdministrationPage.js